<app-banner [heading]="'SCHOOL HOLIDAYS'" [detail]="'ACHIEVING HIGH STANDARDS'"></app-banner>

<main id="main">
   
    <!-- ======= About Section ======= -->
    <section id="about" class="about">

      <div class="container">
        <div class="row">
			<div class="col-lg-12 col-md-6">
			<!-- <h3 class="heading">LIST OF HOLIDAYS TO BE OBSERVED BY TAGORE GLOBAL SCHOOL</h3> -->
			<p class="heading2">DURING THE CALENDAR YEAR 2021</p>
					 <!-- ======= Table Section ======= -->
					<table class="table table-hover">
						  <thead>
							<tr>
							  <th width="5%">S.NO.</th>
							  <th width="35%">MONTH</th>
							  <th scope="60%">DATE</th>
							</tr>
						  </thead>
						  <tbody>
							<tr>
							  <th scope="row">1</th>
							  <td>APRIL 2023</td>
							  <td>22ND APRIL - SATURDAY- ID-UL-FITR / PARSHURAM JAYANTI</td>
							  
							</tr>
							<tr>
							  <th scope="row">2</th>
							  <td>AUGUST 2023</td>
							  <td>15TH AUGUST - TUESDAY - INDEPENDENCE DAY</td>
							  
							</tr>
							<tr>
							  <th scope="row">3</th>
							  <td colspan="">AUGUST 2023</td>
							  <td>30TH AUGUST -WEDNESDAY - RAKSHA BANDHAN</td>
							</tr>
							<tr>
							  <th scope="row">4</th>
							  <td colspan="">SEPTEMBER 2023</td>
							  <td>06TH SEPTEMBER - WEDNESDAY - JANMASHTAMI </td>
							</tr>
							<tr>
							  <th scope="row">5</th>
							  <td colspan="">OCTOBER 2023</td>
							  <td>02ND OCTOBER - MONDAY - MAHATAMA GANDHI JAYANTI</td>
							</tr>
							<tr>
							  <th scope="row">6</th>
							  <td colspan="">OCTOBER 2023</td>
							  <td>24TH OCTOBER - TUESDAY -  VIJAYA DASHMI</td>
							</tr>
							<tr>
							  <th scope="row">7</th>
							  <td colspan="">NOVEMBER 2023</td>
							  <td>01ST NOVEMBER - WEDNESDAY - HARYANA DAY</td>
							</tr>
							<tr>
							  <th scope="row">8</th>
							  <td colspan="">NOVEMBER 2023</td>
							  <td>12TH NOVEMBER - SUNDAY - DIWALI</td>
							</tr>
							<tr>
							  <th scope="row">9</th>
							  <td colspan="">NOVEMBER 2023</td>
							  <td>13TH NOVEMBER - MONDAY - GOVARDHAN PUJA/ VISHVAKARMA DAY</td>
							</tr>
							<tr>
							<th scope="row">10</th>
							  <td colspan="">NOVEMBER 2023</td>
							  <td>15TH  NOVEMBER - WEDNESDAY - BHAI DOOJ </td>
							</tr>
							<tr>
							  <th scope="row">11</th>
							  <td colspan="">NOVEMBER 2023</td>
							  <td>27TH NOVEMBER - MONDAY - GURU NANAK DEV JAYANTI</td>
							</tr>
							<tr>
							  <th scope="row">12</th>
							  <td colspan="">DECEMBER 2023</td>
							  <td>25TH DECEMBER - MONDAY - CHRISTMAS</td>
							</tr>
							<tr>
								<th scope="row">13</th>
								<td colspan="">JANUARY 2024</td>
								<td>26TH JANUARY - FRIDAY - REPUBLIC DAY</td>
							  </tr>
							  <tr>
								<th scope="row">14</th>
								<td colspan="">MARCH 2024</td>
								<td>08TH MARCH - FRIDAY - MAHA SHIVRATRI</td>
							  </tr>
							  <tr>
								<th scope="row">15</th>
								<td colspan="">MARCH 2024</td>
								<td>25TH MARCH - MONDAY - HOLI</td>
							  </tr>

						  </tbody>
					</table>
					<!-- ======= Table Section ======= -->
		  </div>
		  <div class="col-lg-12 col-md-6">
				<h4 class="heading2">School Vacation Schedule</h4>
				<p>Summer Vacation : 1st June to 30th June (Both holidays inclusive)</p>

				<p>Winter Break : As Per Government guidlines</p>
		  
		  </div>
	  </div>
	</div>  

    </section><!-- End About Section -->
	
  </main>